enum RimType {
  NOT_ON_RIM = 1,
  STEEL = 2,
  ALUMINIUM = 3,
}

export default RimType;
